import { render, staticRenderFns } from "./ChooseFormComponent.vue?vue&type=template&id=83302322&scoped=true&"
import script from "./ChooseFormComponent.vue?vue&type=script&lang=js&"
export * from "./ChooseFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChooseFormComponent.vue?vue&type=style&index=0&id=83302322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83302322",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VBtn,VList,VListTile,VListTileTitle,VMenu})
